import $ from 'jquery';

export default function() {
    var dependencyMap = {};

    this.attributes({
        dependentFields: '[data-depends]',
    });

    this.after('initialize', function() {
        this.buildDependencyMap();
        this.bindDependees();
    });

    this.buildDependencyMap = function() {
        var component = this;

        component.select('dependentFields').each(function() {
            var $dependentField = $(this);
            var dependencyData = $dependentField.data('depends');

            var $target = component.getTargetForDependentField($dependentField);

            $.each(dependencyData, function(dependeeField, condition) {
                var dependency = {
                    target: $target,
                    conditions: dependencyData,
                };

                if (dependencyMap[dependeeField] === undefined) {
                    dependencyMap[dependeeField] = [dependency];
                } else {
                    dependencyMap[dependeeField].push(dependency);
                }
            });
        });
    };

    this.bindDependees = function() {
        var component = this;

        $.each(dependencyMap, function(dependeeField, dependencies) {
            component.$node.on('change', '[name="' + dependeeField + '"]', function() {
                $.each(dependencies, function(index, dependency) {
                    if (component.areConditionsSatisfied(dependency.conditions) === true) {
                        dependency.target.removeClass('hidden');
                    } else {
                        dependency.target.addClass('hidden');
                    }
                });
            });
        });
    };

    this.areConditionsSatisfied = function(conditions) {
        var currentValues = this.getValuesForConditions(conditions);
        var isSatisfied = true;

        $.each(conditions, function(dependeeField, condition) {
            if ($.inArray(condition, currentValues[dependeeField]) === -1) {
                isSatisfied = false;
                return;
            }
        });

        return isSatisfied;
    };

    this.getTargetForDependentField = function($dependentField) {
        if ($dependentField.hasClass('fieldset')) {
            return $dependentField;
        } else {
            return $dependentField.closest('.field');
        }
    };

    this.getValuesForConditions = function(conditions) {
        var values = [];

        $.each(conditions, function(dependeeField) {
            var $field = $('[name="' + dependeeField + '"]');
            if ($field.attr('type') === 'radio' || $field.attr('type') === 'checkbox') {
                values[dependeeField] = $field.filter(':checked').map(function() {
                    return this.value;
                });
            } else {
                values[dependeeField] = [$field.val()];
            }
        });

        return values;
    };
}



// WEBPACK FOOTER //
// ./src/web/js/app/modules/mixins/with-dependent-fields.js